import React from "react"
import { Outlet, RouteObject } from "react-router"
import CheckValidVaultSession from "src/check-valid-vault-session"
import { libraryManagerRouteNames } from "src/pages/library-manager/library-manager.route-names"

export const createLibraryManagerRoutes = (): RouteObject[] => [
  {
    element: (
      <>
        <CheckValidVaultSession /> <Outlet />
      </>
    ),
    children: [
      {
        path: libraryManagerRouteNames.standaloneLibrary.route,
        lazy: async () =>
          import("src/pages/library-manager/customer-library/standalone-customer-library"),
      },
      {
        path: libraryManagerRouteNames.embeddedLibrary.route,
        lazy: async () =>
          import("src/pages/library-manager/customer-library/embedded-customer-library"),
      },
      {
        path: libraryManagerRouteNames.survey.route,
        lazy: async () =>
          import("src/pages/library-manager/survey-versions/survey-versions"),
      },
      {
        path: libraryManagerRouteNames.dynamicPreview.route,
        lazy: async () =>
          import("src/components/preview/library-manager-preview-page"),
      },
      {
        path: libraryManagerRouteNames.terminalPage.route,
        lazy: async () =>
          import("src/pages/library-manager/survey-versions/terminal-page"),
      },
    ],
  },
  // manage survey routes (separate error handling)
  {
    children: [
      {
        path: libraryManagerRouteNames.createSurvey.route,
        lazy: async () =>
          import("src/pages/library-manager/manage-library-survey/create-library-survey"),
      },
      {
        path: libraryManagerRouteNames.edit.route,
        lazy: async () =>
          import("src/pages/library-manager/manage-library-survey/edit-library-survey-version"),
      },
      {
        path: libraryManagerRouteNames.viewDetails.route,
        lazy: async () =>
          import("src/pages/library-manager/manage-library-survey/view-library-survey-version"),
      },
    ],
  },
  // unauthenticated routes
  {
    children: [
      {
        path: libraryManagerRouteNames.globalPreview.route,
        lazy: () =>
          import("src/components/preview/library-manager-preview-page"),
      },
      {
        path: libraryManagerRouteNames.embeddedStaticPage.route,
        lazy: async () =>
          import("src/pages/library-manager/customer-library/embedded-static-page"),
      },
    ],
  },
]
